/* =====================================================================
   Tann Trim — Homepage redesign shared behaviour
   - [data-tth-rail]: mobile = native scroll-snap, desktop = translateX
     slider moved one card per arrow click.
   - .tth-add: flips to the "✓ Added" state after a click (the add itself
     is done by the global .tt-product-card__atc handler in theme.liquid).
   ===================================================================== */
(function () {
  if (window.ttHome) return;

  var desktop = window.matchMedia('(min-width: 750px)');

  function Rail(root) {
    this.root = root;
    this.viewport = root.querySelector('.tth-rail__viewport');
    this.track = root.querySelector('.tth-rail__track');
    this.prev = root.querySelector('[data-tth-prev]');
    this.next = root.querySelector('[data-tth-next]');
    this.off = 0;
    if (!this.viewport || !this.track) return;

    var self = this;
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.off - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.off + 1); });
    root.ttRail = this;
    this.update();
  }

  Rail.prototype.items = function () {
    return this.track.querySelectorAll('.tth-rail__item');
  };

  Rail.prototype.step = function () {
    var items = this.items();
    if (!items.length) return 0;
    var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return items[0].getBoundingClientRect().width + gap;
  };

  Rail.prototype.maxOff = function () {
    var step = this.step();
    if (!step) return 0;
    var visible = Math.round((this.viewport.clientWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0)) / step);
    return Math.max(0, this.items().length - visible);
  };

  Rail.prototype.go = function (n) {
    this.off = Math.min(Math.max(0, n), this.maxOff());
    this.update();
  };

  Rail.prototype.reset = function () {
    this.off = 0;
    this.viewport.scrollLeft = 0;
    this.update();
  };

  Rail.prototype.update = function () {
    if (!desktop.matches) {
      this.track.style.transform = '';
      return;
    }
    this.off = Math.min(this.off, this.maxOff());
    this.track.style.transform = 'translateX(' + (-this.off * this.step()) + 'px)';
    if (this.prev) this.prev.hidden = this.off <= 0;
    if (this.next) this.next.hidden = this.off >= this.maxOff();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-tth-rail]').forEach(function (el) {
      if (!el.ttRail) new Rail(el);
      else el.ttRail.update();
    });
  }

  function updateAll() {
    document.querySelectorAll('[data-tth-rail]').forEach(function (el) {
      if (el.ttRail) el.ttRail.update();
    });
  }

  var resizeRaf = 0;
  window.addEventListener('resize', function () {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(function () {
      resizeRaf = 0;
      updateAll();
    });
  }, { passive: true });
  if (desktop.addEventListener) desktop.addEventListener('change', updateAll);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tth .tth-add');
    // No disabled check: the global capture-phase handler disables the
    // button (loading state) before this bubble-phase listener runs.
    if (!btn || !btn.closest('form')) return;
    btn.classList.add('is-added');
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.ttHome = { initRails: init };
  init(document);
})();
